import { useQuery } from 'react-query'
import { useDebounce } from 'use-debounce'
import axios from '../../utils/axios'
import { API_BASE_URL } from '../../constants'

const fetchGeneSearch = async ({ q, limit }) => {
  const { data } = await axios.get(`${API_BASE_URL}/unified/annotations/genes/search`, {
    params: { q, limit },
  })
  return data
}

export const useGeneSearch = (query, { limit = 10, minChars = 2, delayMs = 200 } = {}) => {
  const [debounced] = useDebounce(query ?? '', delayMs)
  const q = debounced?.trim() || ''
  return useQuery(['unified', 'gene-search', q, limit], () => fetchGeneSearch({ q, limit }), {
    enabled: q.length >= minChars,
    staleTime: 60_000,
  })
}
